// Formats français : montants en centimes, dates civiles, durées.

const eur = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
const dateFmt = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", year: "numeric" });
const dateLong = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" });
const dateTimeFmt = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
const monthFmt = new Intl.DateTimeFormat("fr-FR", { month: "long", year: "numeric" });

export function money(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || Number.isNaN(cents)) return "—";
  return eur.format(cents / 100);
}

/** Convertit une saisie (« 850 », « 850,50 », « 1 240,00 € ») en centimes. Renvoie null si invalide. */
export function parseEuros(input: string): number | null {
  const cleaned = input.replace(/[\s  €]/g, "").replace(",", ".");
  if (!/^-?\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const [int, dec = ""] = cleaned.replace("-", "").split(".");
  const cents = parseInt(int, 10) * 100 + parseInt((dec + "00").slice(0, 2), 10);
  return cleaned.startsWith("-") ? -cents : cents;
}

export function centsToInput(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return "";
  const abs = Math.abs(cents);
  const s = `${Math.floor(abs / 100)},${String(abs % 100).padStart(2, "0")}`;
  return cents < 0 ? `-${s}` : s;
}

function toDate(v: string | Date): Date {
  if (v instanceof Date) return v;
  // Une date civile « 2026-09-26 » est interprétée à midi pour éviter les décalages de fuseau.
  return /^\d{4}-\d{2}-\d{2}$/.test(v) ? new Date(`${v}T12:00:00`) : new Date(v);
}

export function date(v: string | Date | null | undefined): string {
  return v ? dateFmt.format(toDate(v)) : "—";
}
export function dateLongFmt(v: string | Date | null | undefined): string {
  return v ? dateLong.format(toDate(v)) : "—";
}
export function dateTime(v: string | Date | null | undefined): string {
  return v ? dateTimeFmt.format(toDate(v)) : "—";
}
export function month(v: string | Date | null | undefined): string {
  return v ? monthFmt.format(toDate(v)) : "—";
}
export function today(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
export function percent(bp: number | null | undefined, digits = 1): string {
  if (bp === null || bp === undefined) return "—";
  return `${(bp / 100).toLocaleString("fr-FR", { minimumFractionDigits: digits, maximumFractionDigits: digits })} %`;
}
export function fileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / 1024 / 1024).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} Mo`;
}
